import SlideApi from '@/api/slide'
import Socket from '@/socket'
import { isElementInViewport } from '@/utils/dom.utils'

export default {
  backupDeletedSlides(component, oldSlides, newSlides, previousSelectingSlides) {
    const payload = {
      type: 'DeleteSlides',
      data: {
        slides: oldSlides,
        selectingSlides: previousSelectingSlides,
      },
      newData: {
        slides: newSlides,
        selectingSlides: previousSelectingSlides,

      },
      slideActiveId: component.slideActive.id,
    }
    component.addActionToHistory(payload)
    return payload
  },

  backupDuplicateSlides(component, oldSlides, newSlides, originalSlides, duplicatedSlides) {
    const payload = {
      type: 'DuplicateSlides',
      data: {
        slides: oldSlides,
        originalSlides,
        duplicatedSlides,
      },
      newData: {
        slides: newSlides,
        originalSlides,
        duplicatedSlides,

      },
      slideActiveId: component.slideActive.id,
    }
    component.addActionToHistory(payload)
  },

  async undoDuplicateSlides(component, data) {
    if (!data.slides || data.slides.length === 0) return

    await SlideApi.updateSlides({
      presentationId: component.presentation.id,
      socketId: Socket.getSocketId(),
      slides: data.duplicatedSlides.map((s) => ({
        id: s.id,
        deleted: true, // Remove the duplicated slides
      })),
    })
    component.presentation.slides = data.slides
    if (data.originalSlides) {
      component.selectedSlideIds = data.originalSlides.map((i) => i.id)
      // active the original slides
      component.$nextTick(() => {
        component.selectSlides(component.selectedSlideIds)
        component.makeSlideActive(data.originalSlides[data.originalSlides.length - 1])
      })
    }
  },

  async redoDuplicateSlides(component, data) {
    await SlideApi.updateSlides({
      presentationId: component.$route.params.id,
      socketId: Socket.getSocketId(),
      slides: data.duplicatedSlides.map((s) => ({
        id: s.id,
        deleted: false, // Bring back the duplicated slides before
      })),
    })
    component.presentation.slides = data.slides
    if (data.duplicatedSlides) {
      component.selectedSlideIds = data.duplicatedSlides.map((i) => i.id)
      // active the duplicated slides
      component.$nextTick(() => {
        component.selectSlides(component.selectedSlideIds)
        component.makeSlideActive(data.duplicatedSlides[data.duplicatedSlides.length - 1])
      })
    }
  },

  async undoDeleteSlides(component, data) {
    if (!data.slides || data.slides.length === 0) return
    const revertedSlides = data.slides.map((s) => ({
      ...s,
      deleted: false,
    }))

    const payload = revertedSlides.map((s) => ({
      id: s.id,
      deleted: false,
      order: s.order,
    }))
    await SlideApi.updateSlides({
      presentationId: component.$route.params.id,
      socketId: Socket.getSocketId(),
      slides: payload,
    })
    component.presentation.slides = revertedSlides
    if (data.selectingSlides && data.selectingSlides.length > 0) {
      component.selectedSlideIds = data.selectingSlides.map((i) => i.id)
      component.$nextTick(() => {
        component.selectSlides(component.selectedSlideIds)
        component.makeSlideActive(data.selectingSlides[data.selectingSlides.length - 1])
        if (!isElementInViewport(document.getElementById(`slide-${component.selectedSlideIds[0]}`))) {
          document.getElementById(`slide-${component.selectedSlideIds[0]}`).scrollIntoView()
        }
      })
    }
  },

  async redoDeleteSlides(component, data) {
    await component.handleDeleteSlides(data.selectingSlides)
  },

  backupCreateSlides(component, beforeCreateSlides, afterCreateSlides, createdSlide) {
    const createdSlideIndex = afterCreateSlides.findIndex((s) => s.id === createdSlide.id)
    const payload = {
      type: 'CreateSlide',
      data: {
        slides: beforeCreateSlides,
        createdSlide,
        createdSlideIndex,
      },
      newData: {
        slides: afterCreateSlides,
        createdSlide,
        createdSlideIndex,
      },
    }
    component.addActionToHistory(payload)
  },

  async undoCreateSlide(component, data) {
    await SlideApi.updateSlides({
      presentationId: component.presentation.id,
      socketId: Socket.getSocketId(),
      slides: [
        { id: data.createdSlide.id, deleted: true },
      ],
    })
    component.presentation.slides = data.slides
    if (data.createdSlideIndex > 0) {
      // active the slide before the created slide
      component.selectedSlideIds = [data.slides[data.createdSlideIndex - 1].id]
      component.$nextTick(() => {
        component.selectSlides(component.selectedSlideIds)
        component.makeSlideActive(data.slides[data.createdSlideIndex - 1])
      })
    }
  },

  async redoCreateSlide(component, data) {
    await SlideApi.updateSlides({
      presentationId: component.presentation.id,
      socketId: Socket.getSocketId(),
      slides: [
        { id: data.createdSlide.id, deleted: false },
      ],
    })
    component.presentation.slides = data.slides
    if (data.createdSlideIndex > 0) {
      component.selectedSlideIds = [data.slides[data.createdSlideIndex].id]
      // active the newly created slide
      component.$nextTick(() => {
        component.selectSlides(component.selectedSlideIds)
        component.makeSlideActive(data.slides[data.createdSlideIndex])
      })
    }
  },
}
